/** Hash + href used by all Book a demo links */
export const BOOK_DEMO_HREF = '/#contact';
export const BOOK_DEMO_HASH = '#contact';

export function shouldOpenDemoModalFromHash(hash = '') {
  return hash === BOOK_DEMO_HASH;
}

export function isBookDemoTrigger(target: EventTarget | null) {
  if (!target || !(target instanceof Element)) return false;

  const el = target.closest('[data-book-demo], a, button');
  if (!el) return false;

  // Form submit buttons (e.g. modal "Book demo") must not open/trap the modal
  if (el.closest('.demo-modal, .demo-overlay, .contact-form')) return false;
  if (el instanceof HTMLButtonElement && el.type === 'submit') return false;

  if (el.hasAttribute('data-book-demo')) return true;

  const href = (el.getAttribute('href') || '').trim().toLowerCase();
  if (href.endsWith(BOOK_DEMO_HASH) || href === BOOK_DEMO_HASH) return true;

  const txt = (el.textContent || '').trim().toLowerCase();
  return (
    txt.startsWith('book a demo') ||
    txt.startsWith('book demo') ||
    txt.startsWith('request a demo') ||
    txt.startsWith('talk to our team') ||
    txt === 'demo'
  );
}
